import React, { Component } from "react";
import { Provider, inject, observer } from "mobx-react";
import { UserManagementStore } from "../../stores";
import { WithStoresComponentProps, WithStoresWrappedComponent } from "../../constants/common-types";
import { ApiStoreModel } from "../../stores/apiStore/apiStore";

type InjectedProps<T> = WithStoresComponentProps<T> & {
  apiStore: ApiStoreModel;
};

const withEmailVerificationStores = <T extends {}>(WrappedComponent: WithStoresWrappedComponent<T>) => {
  @inject("apiStore")
  @observer
  class WithEmailVerificationStores extends Component<WithStoresComponentProps<T>> {
    get injected() {
      return this.props as InjectedProps<T>;
    }
    userManagementStore: UserManagementStore;
    constructor(props: WithStoresComponentProps<T>) {
      super(props);

      const { api } = this.injected.apiStore;

      this.userManagementStore = new UserManagementStore(api);
    }
    render() {
      return (
        <Provider userManagementStore={this.userManagementStore}>
          <WrappedComponent {...this.props} />
        </Provider>
      );
    }
  }

  return WithEmailVerificationStores;
};

export default withEmailVerificationStores;
